// eslint-disable-next-line import/no-anonymous-default-export
export default {
  try: '₺ Turkish Lira',
  usd: '$ US Dollar',
  eur: '€ Euro',
  gbp: '£ British Pound',
  gold: 'Gold'
};
